import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ModalService } from 'src/app/Services/confirmation-modal/modalServie.service';
import {
  ExamManagementService,
  IMockExamQuestion,
} from 'src/app/Services/exam-management/exam-management.service';
import { ConstantVars } from 'src/app/utils/constants/constants';
export interface ITransformedIMockExamQuestionResponse {
  Subject_Id: number;
  Current_Number_Of_Question: number;
  Total_Number_Of_Question: number;
  Subject_Name: string;
  Subject_Total_Number_Of_Question: number;
  Subject_Current_Number_Of_Question: number;
  isCollapsed: boolean;
  questions: IQuestionMockExam[];
}

export interface IQuestionMockExam {
  Path_Name: string;
  Question_ID: string;
  Question_Text: string;
  Answer_Choices: IAnswerChoice[];
}

export interface IAnswerChoice {
  Answer_Choice_Sequence_Number: number;
  Answer_Choice_Id: number;
  Answer_Choice_Text: string;
  Right_Answer_Ind: string;
  All_Of_The_Above_Or_None_Of_The_Above_Ind: string;
  Selected_IND: string;
}

@Component({
  selector: 'app-mock-exam-question',
  templateUrl: './mock-exam-question.component.html',
  styleUrls: ['./mock-exam-question.component.css'],
  encapsulation: ViewEncapsulation.Emulated,
})
export class MockExamQuestionComponent implements OnInit {
  MockExamId: number = 0;
  private destroy$ = new Subject<void>(); // Used for unsubscribing
  subjects: ITransformedIMockExamQuestionResponse[] = [];
  courseId: number;
  MockExamSequenceNumber: number;
  ExamAgencyName: any;
  CourseName: any;
  ExamYear: any;
  MocKExamSequenceNumber: number;
  subjectIdOpen: number | null = null;


  constructor(
    private ExamService: ExamManagementService,
    private route: ActivatedRoute,
    private router: Router,
    private modalService: ModalService,
    private readonly toaster: ToastrService
  ) {}

  ngOnInit(): void {
    this.route.queryParams
      .pipe(takeUntil(this.destroy$))
      .subscribe((queryParams) => {
        this.courseId = +queryParams['c_id'];
        this.MockExamSequenceNumber = +queryParams['m_Seq'];
        this.ExamAgencyName = queryParams['eA_Name'];
        this.CourseName = queryParams['c_Name'];
        this.ExamYear = queryParams['eY_Name'];
        this.MocKExamSequenceNumber = +queryParams['e_Seq'];
      });
    this.route.params.pipe(takeUntil(this.destroy$)).subscribe((res) => {
      this.MockExamId = +res.id;
      this.getMockExamQuestion();
    });
  }
  getMockExamQuestion() {
    const payload = {
      CourseTestId: this.MockExamId,
      CourseTestStatusTypeCode: null,
    };
    this.ExamService.getMockExamQuestion(payload).subscribe((res) => {
      this.subjects = res;
      if (this.subjectIdOpen) {
        this.subjects.forEach(sub => {
          sub.isCollapsed = (sub.Subject_Id !== this.subjectIdOpen);
        });
      }
    });
  }

  AddEditQuestion(item: ITransformedIMockExamQuestionResponse) {
    const navigationExtras: NavigationExtras = {
      queryParams: {
        c_id: this.courseId,
        eA_Name: this.ExamAgencyName,
        c_Name: this.CourseName,
        eY_Name: this.ExamYear,
        s_id: item.Subject_Id,
        t_q: item.Subject_Total_Number_Of_Question,
        c_q: item.Subject_Current_Number_Of_Question,
        s_name: item.Subject_Name,
        // m_Seq: this.MockExamSequenceNumber,
      },
      skipLocationChange: false,
    };
    this.router.navigate(
      ['Exam/AddEditMockExamsQuestion', this.MockExamId],
      navigationExtras
    );
  }
  async onDelete(subject:ITransformedIMockExamQuestionResponse,question: IQuestionMockExam) {
    try {
      const result = await this.modalService.open(
        'Confirmation',
        `Do you want to remove this Question?`
      );

      if (result) {
        this.subjectIdOpen = subject.Subject_Id;
        const payload = {
          UDTTestQuestion: [
            {
              CourseTestId: this.MockExamId,
              QuestionId: question.Question_ID,
              QuestionNumber: 0,
              RightAnswerScore: 0,
              WrongAnswerScore: 0,
              TimeToAnswerInSeconds: 0,
              OptionalQuestionInd: 'N',
              SelectedIND: 'N',
            },
          ],

          UDTTestQuestionAnswerChoice: question.Answer_Choices.map(
            (choice) => ({
              CourseTestId: this.MockExamId,
              QuestionId: question.Question_ID,
              AnswerChoiceId: choice.Answer_Choice_Id, // Ensure number type
              AnswerChoiceSequenceNumber: 0,
              SelectedIND: 'N',
            })
          ),
        };

        this.ExamService.insertOrUpdateTestQuestion(payload).subscribe(
          (res) => {
            console.log(res);
            this.toaster.success('Questions Deleted successfully', '', {
              timeOut: ConstantVars.ToastSucessTimeout,
            });
            this.getMockExamQuestion();
          },
          (error) => {
            console.log(error);

            this.toaster.error(error.error.Message, '', {
              timeOut: ConstantVars.ToastErrorTimeout,
            });
          }
        );
      }
    } catch (error) {
      console.log(error);
    }
  }

  onEdit(
    item: ITransformedIMockExamQuestionResponse,
    question: IQuestionMockExam
  ) {
    const navigationExtras: NavigationExtras = {
      queryParams: {
        c_id: this.courseId,
        eA_Name: this.ExamAgencyName,
        c_Name: this.CourseName,
        eY_Name: this.ExamYear,
        s_id: item.Subject_Id,
        t_q: item.Subject_Total_Number_Of_Question,
        c_q: item.Subject_Current_Number_Of_Question,
        s_name: item.Subject_Name,
        q_id: question.Question_ID,
        // m_Seq: this.MockExamSequenceNumber,
      },
      skipLocationChange: false,
    };
    this.router.navigate(
      ['Exam/AddEditMockExamsQuestion', this.MockExamId],
      navigationExtras
    );
  }
  ngOnDestroy(): void {
    this.destroy$.next(); // Emit value to trigger unsubscription
    this.destroy$.complete(); // Ensures Subject is fully closed
  }
}
